//
import BranchOfficeModel from "@/models/General/GBranchOffice"
import UserModel from "@/models/General/GUser"

//
import { required } from "@/services/validations"

//
export default [
    {
        name: "pos_workstation_type_id",
        type: "autocomplete",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: [
                {
                    text: "Sala",
                    value: 1,
                },
                {
                    text: "Terreno",
                    value: 2,
                },
                {
                    text: "Call Center",
                    value: 3,
                },
                {
                    text: "Impresion Automatica",
                    value: 5,
                },
            ],
            label: "Tipo",
            rules: [ required ],
        },
    },
    {
        name: "g_branch_office_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: "name",
            itemValue: "id",
            label: "Sucursal",
            model: BranchOfficeModel,
            noObject: true,
            paramSearch: "address",
            rules: [ required ],
        },
    },
    {
        name: "g_seller_user_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: "full_name",
            itemValue: "id",
            label: "Vendedor",
            model: UserModel,
            paramFilter: {
                is_ground_seller: true,
            },
            noObject: true,
        },
    },
]